module.exports = __webpack_public_path__ + "fonts/DINPro-Light.1b4615cf.ttf";